/**
 * CSSをセレクタ単位のMapに変換する
 * Mapは挿入順序を保持するため、Cascading（順序依存）を壊さない
 */
function parseCssToMap(css) {
    const map = new Map();
    if (!css) return map;

    // コメントを除去し、パースミスを防ぐ
    const cleanCss = css.replace(/\/\*[\s\S]*?\*\//g, '');

    // セレクタ { プロパティ } の形を抽出する正規表現
    // メディアクエリ等の入れ子には非対応だが、標準的なスタイル指定を確実に拾う
    const regex = /([^{]+)\{([^}]+)\}/g;
    let match;

    while ((match = regex.exec(cleanCss)) !== null) {
        const selector = match[1].trim()
            .replace(/\s+/g, ' '); // セレクタ内の余分な空白を正規化
        const body = match[2].trim();
        map.set(selector, body);
    }
    return map;
}

/**
 * 既存のCSSと新しいCSSをマージする
 * @param {string} oldCss - 現在のCSS
 * @param {string} newCss - AIが生成したCSS（差分または全量）
 * @param {string[]} deletedSelectors - 削除したいセレクタのリスト
 * @returns {string} マージ後のCSS
 */
export function mergeCss(oldCss, newCss, deletedSelectors = []) {
    if (!oldCss) return newCss; // 既存がなければそのまま

    const oldMap = parseCssToMap(oldCss);
    const newMap = parseCssToMap(newCss);

    // 1. 既存のMapをベースにする
    const mergedMap = new Map(oldMap);

    // 2. AIから送られてきた内容で上書き、または末尾に追加
    newMap.forEach((body, selector) => {
        // AIが中身を省略（/* ... */ など）していない場合のみ更新
        const isOmitted = body.includes('...') || (body.includes('/*') && body.length < 20);
        if (!isOmitted) {
            mergedMap.set(selector, body);
        }
    });

    // 3. 明示的に指定されたセレクタを削除
    if (Array.isArray(deletedSelectors)) {
        deletedSelectors.forEach(sel => {
            const normalizedSel = sel.trim().replace(/\s+/g, ' ');
            mergedMap.delete(normalizedSel);
        });
    }

    // 4. 文字列に再構成
    let result = "/* Managed by AI Agent (Merged) */\n\n";
    mergedMap.forEach((body, selector) => {
        result += `${selector} {\n  ${body}\n}\n\n`;
    });

    return result.trim();
}